var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('v-data-table', {
    staticClass: "elevation-1 ma-8",
    attrs: {
      "items": _vm.dashboard,
      "headers": _vm.dashboardHeaders,
      "loading": _vm.loading,
      "disable-sort": "",
      "disable-pagination": "",
      "hide-default-footer": ""
    },
    scopedSlots: _vm._u([{
      key: "item.issue",
      fn: function fn(_ref) {
        var item = _ref.item;
        return [_c('v-col', [_vm._v(_vm._s(item.issue.count.format()) + "건(" + _vm._s(item.issue.price.format()) + "원)")])];
      }
    }, {
      key: "item.pay",
      fn: function fn(_ref2) {
        var item = _ref2.item;
        return [_c('v-col', [_vm._v(_vm._s(item.pay.count.format()) + "건(" + _vm._s(item.pay.price.format()) + "원)")])];
      }
    }, {
      key: "item.cancel",
      fn: function fn(_ref3) {
        var item = _ref3.item;
        return [_c('v-col', [_vm._v(_vm._s(item.cancel.count.format()) + "건(" + _vm._s(item.cancel.price.format()) + "원)")])];
      }
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }